import { Star, Quotes } from "@phosphor-icons/react";
import { useEffect, useState } from "react";

const REVIEWS = [
  {
    quote: "I travel between three clinics a week. CryoVault is the only cooler I trust to keep peptides in range door-to-door.",
    name: "Dr. Elena Marsh",
    role: "Research Scientist",
    meta: "38 · Verified buyer",
    initials: "EM",
  },
  {
    quote: "Silent enough to sit on my nightstand and cold enough that my endo signed off on it for my insulin.",
    name: "Marcus Reid",
    role: "Pharmacology Professor",
    meta: "42 · Verified buyer",
    initials: "MR",
  },
  {
    quote: "I finally stopped stressing about hotel mini-fridges. Ten hours on a charge got me across two continents.",
    name: "Sofia Ines",
    role: "Clinical Trials Lead",
    meta: "29 · Verified buyer",
    initials: "SI",
  },
  {
    quote: "The XL holds my whole month's supply. Digital readout, real temperature — this is what I wanted for years.",
    name: "James O.",
    role: "Independent Researcher",
    meta: "51 · Verified buyer",
    initials: "JO",
  },
  {
    quote: "TSA didn't blink. Vials stayed at 4.2°C the entire 11-hour flight. Worth every dollar.",
    name: "Aiko Tanaka",
    role: "Bioanalytical Chemist",
    meta: "34 · Verified buyer",
    initials: "AT",
  },
  {
    quote: "Feels like a piece of medical hardware, not a gadget. That's exactly what I wanted holding my medication.",
    name: "Priya Kaur",
    role: "Peptide Researcher",
    meta: "46 · Verified buyer",
    initials: "PK",
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setActive((v) => (v + 1) % REVIEWS.length), 6000);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      data-testid="testimonials"
      className="py-14 sm:py-20 bg-navy-deep relative overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 left-1/4 h-96 w-96 rounded-full bg-royal/25 blur-3xl" />
        <div className="absolute -bottom-32 right-10 h-80 w-80 rounded-full bg-teal-brand/15 blur-3xl" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <div className="overline text-teal-brand">Loved by 10,000+ customers</div>
          <h2 className="font-display mt-4 text-4xl md:text-5xl lg:text-[54px] font-bold text-white tracking-tight leading-[1.05]">
            Real results. Real peace of mind.
          </h2>
          <div className="mt-5 inline-flex items-center gap-3">
            <div className="flex items-center gap-0.5 text-teal-brand">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={14} weight="fill" />
              ))}
            </div>
            <span className="font-mono-data text-white/80 text-sm">
              4.9 · 2,314 reviews
            </span>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className={`reveal relative rounded-3xl backdrop-blur-xl border p-7 transition-all duration-500 ${
                active === i
                  ? "bg-white/10 border-teal-brand/50 shadow-[0_0_50px_-12px_rgba(1,207,198,0.45)]"
                  : "bg-white/5 border-white/10"
              }`}
            >
              <Quotes
                size={40}
                weight="fill"
                className="text-teal-brand/70"
              />
              <p className="mt-4 text-white/90 leading-relaxed text-[15px]">
                {r.quote}
              </p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-white/10">
                <div className="h-10 w-10 rounded-full bg-signature-gradient grid place-items-center text-white font-semibold text-sm">
                  {r.initials}
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">
                    {r.name}
                  </div>
                  <div className="font-mono-data text-teal-brand text-[10.5px] uppercase tracking-widest mt-0.5">
                    {r.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex items-center justify-center gap-2">
          {REVIEWS.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              aria-label={`Show testimonial ${i + 1}`}
              className={`h-1.5 rounded-full transition-all ${
                active === i ? "bg-teal-brand w-8" : "bg-white/25 w-1.5"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
